<img src="assets/images/icon-guidance.png" width="24px" height="24px" alt="" aria-hidden="true" />
<p class="m-0 line-height-2">
  <ng-content></ng-content>
</p>
